import { onPaginationViewportChange, renderPagination } from '../utils/pagination';
import LevitPopup from '../utils/levit-popup';
import FormIframe, { bindFormEmbedWarmup } from '../utils/form-iframe';

class BuildOpportunities {
	constructor(element) {
		this.el = element;
		this.grid = element.querySelector('[data-build-grid]');
		this.emptyEl = element.querySelector('[data-build-empty]');
		this.paginationWrap = element.querySelector('[data-pagination]');
		this.paginationPages = element.querySelector('[data-pagination-pages]');
		this.paginationRange = element.querySelector('[data-pagination-range]');
		this.perPageSelect = element.querySelector('[data-per-page]');

		this.popupEl = document.getElementById('levit-popup-build');
		this.popupTitle = this.popupEl?.querySelector('[data-build-popup-title]');
		this.popupCost = this.popupEl?.querySelector('[data-build-popup-cost]');
		this.popupDescription = this.popupEl?.querySelector('[data-build-popup-description]');
		this.popupFormWrap = this.popupEl?.querySelector('[data-build-popup-form]');

		this.state = {
			paged: 1,
			postsPerPage: parseInt(element.dataset.postsPerPage, 10) || 12,
		};

		this.records = [...element.querySelectorAll('.build-card')].map(
			(card, index) => this.buildRecord(card, index)
		);

		this.unsubscribePaginationViewport = onPaginationViewportChange(() => this.renderPagination());

		this.formIframe = this.popupFormWrap
			? new FormIframe(this.popupFormWrap, {
				className: 'build-popup__form-iframe',
				title: 'Donation form',
			})
			: null;

		this.popup = this.popupEl
			? new LevitPopup(this.popupEl, {
				bodyClass: 'build-popup-open',
				onClose: () => this.formIframe?.teardown(),
			})
			: null;

		this.initControls();
		this.initCards();
		this.applyView();
	}

	buildRecord(card, index) {
		return {
			el: card,
			index,
			clickable: !card.classList.contains('is-claimed'),
			title: card.dataset.title || '',
			cost: card.dataset.cost || '',
			description: card.dataset.description || '',
			formSrc: card.dataset.formSrc || '',
		};
	}

	initControls() {
		this.paginationPages?.addEventListener('click', (event) => {
			const button = event.target.closest('[data-page]');
			if (!button || button.classList.contains('is-active') || button.classList.contains('is-disabled')) return;
			const page = parseInt(button.dataset.page, 10);
			if (page > 0 && page <= this.getTotalPages()) {
				this.state.paged = page;
				this.applyView();
				this.scrollToGrid();
			}
		});

		this.perPageSelect?.addEventListener('change', () => {
			this.state.postsPerPage = parseInt(this.perPageSelect.value, 10) || this.state.postsPerPage;
			this.state.paged = 1;
			this.applyView();
		});
	}

	initCards() {
		this.records.forEach((record) => {
			if (!record.clickable) return;
			bindFormEmbedWarmup(record.el, record.formSrc, this.formIframe, () => !!this.popup?.isOpen());
			record.el.addEventListener('click', () => this.openPopup(record));
			record.el.addEventListener('keydown', (event) => {
				if (event.key === 'Enter' || event.key === ' ') {
					event.preventDefault();
					this.openPopup(record);
				}
			});
		});
	}

	getTotalPages() {
		return Math.max(1, Math.ceil(this.records.length / this.state.postsPerPage));
	}

	applyView() {
		const total = this.records.length;
		const totalPages = this.getTotalPages();
		if (this.state.paged > totalPages) this.state.paged = totalPages;

		const start = (this.state.paged - 1) * this.state.postsPerPage;
		const end = start + this.state.postsPerPage;

		this.records.forEach((record, i) => {
			record.el.hidden = i < start || i >= end;
		});

		if (this.emptyEl) this.emptyEl.hidden = total > 0;

		this.renderPagination();
	}

	renderPagination() {
		const totalPages = this.getTotalPages();
		const totalPosts = this.records.length;

		if (this.paginationWrap) {
			this.paginationWrap.hidden = totalPosts === 0;
		}

		renderPagination({
			pagesEl: this.paginationPages,
			rangeEl: this.paginationRange,
			wrapEl: this.paginationWrap,
			paged: this.state.paged,
			totalPages,
			totalPosts,
			postsPerPage: this.state.postsPerPage,
			cssPrefix: 'library-pagination',
		});
	}

	scrollToGrid() {
		this.grid?.scrollIntoView({ behavior: 'smooth', block: 'start' });
	}

	openPopup(record) {
		if (!this.popup) return;

		if (this.popupTitle) this.popupTitle.textContent = record.title;
		if (this.popupCost) this.popupCost.textContent = record.cost;
		if (this.popupDescription) this.popupDescription.textContent = record.description;

		const hasForm = !!record.formSrc;
		this.popupEl?.classList.toggle('build-popup--no-form', !hasForm);
		if (hasForm) {
			this.formIframe?.mount(record.formSrc);
		} else {
			this.formIframe?.teardown();
		}

		this.popup.open();
		requestAnimationFrame(() => this.formIframe?.resize());
	}

	closePopup() {
		this.popup?.close();
	}

	destroy() {
		this.popup?.destroy();
		this.unsubscribePaginationViewport?.();
		this.formIframe?.teardown();
	}

	static init() {
		document.querySelectorAll('[data-component="build-opportunities"]').forEach((element) => {
			new BuildOpportunities(element);
		});
	}
}

export default BuildOpportunities;
